import { render, staticRenderFns } from "./invoiceInfo.vue?vue&type=template&id=37d4aa28"
import script from "./invoiceInfo.vue?vue&type=script&lang=js"
export * from "./invoiceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d4aa28')) {
      api.createRecord('37d4aa28', component.options)
    } else {
      api.reload('37d4aa28', component.options)
    }
    module.hot.accept("./invoiceInfo.vue?vue&type=template&id=37d4aa28", function () {
      api.rerender('37d4aa28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/generateContract/invoiceInfo.vue"
export default component.exports